import { render, staticRenderFns } from "./MakeProcessSelector.vue?vue&type=template&id=0870db72&scoped=true&"
import script from "./MakeProcessSelector.vue?vue&type=script&lang=js&"
export * from "./MakeProcessSelector.vue?vue&type=script&lang=js&"
import style0 from "./MakeProcessSelector.vue?vue&type=style&index=0&id=0870db72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0870db72",
  null
  
)

export default component.exports